import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import Modalizer from 'components/modalizer/modalizer'

import { localize } from 'helpers/translator'

import styles from './interactive_video_activity_picker_modal.scss'

class InteractiveVideoActivityPickerModal extends PureComponent {

	buildActivityList = () => {
		const activityListItems = this.props.activityList
			.map(activity => (
				<li
					key={activity.type.toString()}
					styleName='activity-list-item'
				>
					<button
						styleName='activity-list-item-button'
						onClick={
							() => {
								this.props.createHandler(activity.type)
							}}
					>
						<Isvg src={activity.icon} cacheGetRequests={true} />
						<label styleName='activity-list-item-button-label'>
							{activity.name}
						</label>
					</button>
				</li>
			))

		return (
			<ul styleName='activity-list'>
				{activityListItems}
			</ul>
		)
	}

	render() {
		return (
			<Modalizer
				closeAction={this.props.closeModalHandler}
				nopadding
			>
				<div styleName='container'>
					<div styleName='header'>
						<h2 styleName='header-title'>
							{localize('interactive_video_activityPicker_title_new')}
						</h2>
					</div>
					{this.buildActivityList()}
				</div>
			</Modalizer>
		)
	}
}

InteractiveVideoActivityPickerModal.propTypes = {
	closeModalHandler: PropTypes.func,
	createHandler: PropTypes.func,
	activityList: PropTypes.array.isRequired,
}

InteractiveVideoActivityPickerModal.defaultProps = {
	closeModalHandler: () => {},
	createHandler: () => {},
}

export default CSSModules(
	InteractiveVideoActivityPickerModal, styles, {allowMultiple: true}
)
